var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader),expression:"loader"}],staticClass:"loarderCheck"},[_c('Lottie',{attrs:{"options":_vm.defaultOptions,"height":450,"width":450},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }